$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

     //>=, not <=
    if (scroll >= 100) {
        //clearHeader, not clearheader - caps H
        $(".header").removeClass("sticky");
    }else{
       $(".header").addClass("sticky");
    }
}); //missing );

window.onload = function() {
  if($('.password-popup').hasClass('active')){
    $('body').addClass('passwordfixed');
    $('.password_video').muted = true;
  }else{
    $('body').removeClass('passwordfixed');
      $('.password_video').muted = true;
  } 
};

$('.page-btn, .password-page__access').click(function() {
    if($(this).hasClass('active')) {
        $(this).removeClass('active');
    } else {
        $(this).addClass('active');
    }
    $('.page-btn,.password-page__access').toggle();
});
 
//Mobile once select the size after close fucntion 
$('.color-input').click(function() {
    $('.product-actions__mobile, .mobile-sizes').removeClass('is-active');
});

if ($(window).width() < 767) {
  $(".color-input").on("change", function() {
    var selected = $(this).html();
    $("#selectedin").html("" + selected);
    $('.product-actions__mobile').addClass('m-active');
  });
}

//Password Page Video Always Play
jQuery('.teaser-popup__close').on('click', function(){
  //var videopass = jQuery(".password_video");
      jQuery('.password_video').get(0).play();
      jQuery('.password_video').muted = true;
});

//About us page Slider

// new Swiper ('.about-slider-container', {
//     // Optional parameters
//     direction: 'horizontal',
//     autoplay: {
//       delay: 2500,
//       disableOnInteraction: false,
//     },
//     slidesPerView: 1,
//     spaceBetween: 0,
//     speed: 400,
//     mousewheel: {
//       releaseOnEdges: true,
//     },
//     touchReleaseOnEdges: true,
//     // If we need pagination
//     pagination: {
//       el: '.swiper-pagination',
//       clickable: true,
//     },
// })


//=======================Product-Slider
new Swiper ('.product-detail-container', {
    // Optional parameters
    direction: 'vertical',
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 800,
    mousewheel: {
      releaseOnEdges: true,
    },
    touchReleaseOnEdges: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
})

var swiper = new Swiper('.swiper-container-like', {
    direction: 'horizontal',
    slidesPerView: 1.26,
    spaceBetween: 15,
    speed: 400,

    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    breakpoints: {
        768: {
          slidesPerView: 3,
          loopedSlides: 3,
          spaceBetween: 10
        },
        675: {
          slidesPerView: 2,
          loopedSlides: 2,
          spaceBetween: 20
        }
      },
  });

function muteVideo(e) {
    var muteButton = $(e.target);
    var parentSlider = muteButton.closest('.home-video');
    var targetVideo = parentSlider.find('video')[0];
    if (targetVideo.muted) {
        targetVideo.muted = false;
        parentSlider.find(".icon-mute").attr('src', '//theotherlayer.com/cdn/shop/t/10/assets/unmute.svg');
        parentSlider.find("i").removeClass("fa-play").addClass("fa-pause");
    } else {
        targetVideo.muted = true;
        parentSlider.find(".icon-mute").attr('src', '//theotherlayer.com/cdn/shop/t/10/assets/mute.svg');
        parentSlider.find("i").removeClass("fa-pause").addClass("fa-play");
    }
    $('.home-video').each(function(index, videoparent) {
        var $video = $(videoparent).find('video')[0] ||  $(videoparent).find('video');
        var $icon = $(videoparent).find(".icon-mute");
        var $iconClass = $(videoparent).find("i");
        if ($video !== targetVideo) {
          $video.muted = true;
          $icon.attr('src', '//theotherlayer.com/cdn/shop/t/10/assets/mute.svg');
          $iconClass.removeClass("fa-pause").addClass("fa-play");
        }
    });

    // Toggle mute state for the targeted video
   

    // Loads the clip again, so that it reverts back to the poster image
    targetVideo.addEventListener("ended", function () {
        targetVideo.load();
    });
}

function playVideo(e) {
    var playButton = $(e.target);
    var parentSlider = playButton.closest('.home-video'); // Adjust selector as per your HTML structure
    console.log('parentSlider=', parentSlider)
    var video = parentSlider.find('video')[0];

    if (video.paused) {
        video.play();
        parentSlider.find(".icon-play").attr('src', '//theotherlayer.com/cdn/shop/t/10/assets/pause.svg');
        parentSlider.find("i").removeClass("fa-play").addClass("fa-pause");
    } else {
        video.pause();
        parentSlider.find(".icon-play").attr('src', '//theotherlayer.com/cdn/shop/t/10/assets/play.svg');
        parentSlider.find("i").removeClass("fa-pause").addClass("fa-play");
    }

    // Loads the clip again, so that it reverts back to the poster image
    video.addEventListener("ended", function () {
        video.load();
    });
}

// Add event listeners to all elements with the class 'banner_left_redirect'
document.querySelectorAll('.banner_left_redirect').forEach(function(element) {
  element.addEventListener('click', function() {
      // Trigger the next slide
      document.querySelector('.swiper-button-next').click();
  });
});


    var swiper = new Swiper(".custom_collection_block_slider", {
    direction: 'vertical',
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 800,
    mousewheel: {
        releaseOnEdges: true,
    },

    touchReleaseOnEdges: true,

    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    });

$(document).ready(function() {
  var swiper = new Swiper(".custom_swipercollection", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 1.25,
      },
      767: {
        slidesPerView: 2,
      },
      1025: {
        slidesPerView: 3,
      },
      1499: {
        slidesPerView: 4,
      }
    }
  });
  //===============pre-order-slider
  var swiper_pre_order_slider = new Swiper(".mySwiper.pre_order_slider", {
    slidesPerView: 1,
    loop: false,
    // autoplay: {
    //   delay: 8000, 
    //   disableOnInteraction: false, 
    // },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  });
});



window.addEventListener('load', function () {
window.scrollTo(0, 0);
});

$(document).ready(function(){
    $(".filter_mob").on("click", function(){
        $("html").addClass("filter_custom_open");
    });
    $('.filter_close').click(function(){
        $('html').removeClass('filter_custom_open');
    });
});


$(document).ready(function() {
  $('#SortBy').change(function() {
    var sortByValue = $(this).val();
    var currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('sort_by', sortByValue);
    
    // Fetch the sorted products using AJAX
    $.ajax({
      url: currentUrl.href,
      method: 'GET',
      success: function(response) {
        var html = $(response).find('#ProductGridContainer').html();
        $('#ProductGridContainer').html(html);
      }
    });
  });
});
  
$(document).ready(function(){
    // var color_size = $(".product-actions_sizes label.color-input span").html();
    // $(".product-actions__mobile #selectedin").wrapInner(color_size);
    $('label:not(:last-child) input[type="radio"][name="id"]').removeAttr("checked");
    $('input[type="radio"][name="id"]').on('change', function() {
        $('input[type="radio"][name="id"]').removeAttr('checked');
        $(this).attr('checked', 'checked');
    });
});


// header-account__basket
// const basketButton = document.querySelector('.header-account__basket');
// const cartPopup = document.querySelector('.cart-popup');

// if (basketButton && cartPopup) {
//     basketButton.addEventListener('click', function(event) {
//         event.preventDefault();
//         event.stopPropagation();
//         cartPopup.classList.toggle('cart-popup--visible');
//     });
// }

const basketButton = document.querySelector('.header-account__basket');
const cartPopup = document.querySelector('.cart-popup');
const body = document.body;
const closeButton = document.querySelector('.cart-popup__close');

if (basketButton && cartPopup) {
    basketButton.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        cartPopup.classList.toggle('cart-popup--visible');
        body.classList.toggle('cart-popup-visible');
    });

    // Close the cart popup and remove the class from the body when clicking outside the popup
    document.addEventListener('click', function(event) {
        if (cartPopup.classList.contains('cart-popup--visible') && !cartPopup.contains(event.target) && event.target !== basketButton) {
            cartPopup.classList.remove('cart-popup--visible');
            body.classList.remove('cart-popup-visible');
        }
    });

    // Close the popup when the close button is clicked
    if (closeButton) {
        closeButton.addEventListener('click', function(event) {
            event.stopPropagation();
            cartPopup.classList.remove('cart-popup--visible');
            body.classList.remove('cart-popup-visible');
        });
    }

    // Prevent the popup from closing when clicking inside of it
    cartPopup.addEventListener('click', function(event) {
        event.stopPropagation();
    });

    // Remove the class from the body when clicking anywhere on the body
    body.addEventListener('click', function(event) {
        if (body.classList.contains('cart-popup-visible')) {
            cartPopup.classList.remove('cart-popup--visible');
            body.classList.remove('cart-popup-visible');
        }
    });
}

    document.querySelectorAll('.product-actions__adds').forEach(function(button) {
        button.addEventListener('click', function() {
            const productId = this.getAttribute('data-product-id');
            const quantity = 1;
            const clickedButton = this;

            const data = {
                items: [{
                    quantity: quantity,
                    id: productId
                }]
            };

            fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify(data)
            })
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else if (response.status === 422) {
                    clickedButton.innerHTML = "Out of stock";
                    clickedButton.setAttribute("disabled", true);
                    throw new Error('Out of stock');
                } else {
                    throw new Error('Error adding to cart');
                }
            })
            .then(() => {
                clickedButton.innerHTML = "item added to cart";
                setTimeout(() => {
                    if (clickedButton.getAttribute('data-pre-order-product') === 'true') {
                        clickedButton.innerHTML = "Pre Order Now";
                    } else {
                        clickedButton.innerHTML = "add to basket";
                    }
                }, 5000);
            })
            .catch(error => {
                console.error(error);
            });
        });
    });



var cartswiper = new Swiper(".cart-product-list", {
  slidesPerView: "auto",
  spaceBetween: 20,
});

//============== First-Varinat-Seleted
// document.addEventListener('DOMContentLoaded', function () {
//     // Check if the product form exists
//     var productForms = document.querySelectorAll('.product-detailinfo');
//     productForms.forEach(function (productForm) {
//         // Find all variant inputs
//         var variantInputs = productForm.querySelectorAll('input[name="id"]');
        
//         // Check if there are any variant inputs
//         if (variantInputs.length > 0) {
//             // Set the first variant input as checked
//             variantInputs[0].checked = true;
//         }
//     });
// });

//===================== Without-size-select (No Add-to-cart)

// document.getElementById("product-actions__add").addEventListener("click", function (event) {
//   if (document.querySelector('.Size input[type="radio"][name="id"]:checked') == null) {
//     // alert("Please Select a Size Before Adding to cart.");
//   }
// });

// document.getElementById("product-actions__add").addEventListener("click", function (event) {
//   if (document.querySelector('.Size input[type="radio"][name="id"]:checked') == null) {
//     document.body.classList.add("select_popup");
//   }
// });


// Add event listener to the add-to-cart button
document.getElementById("product-actions__add").addEventListener("click", function (event) {
  if (document.querySelector('.Size input[type="radio"][name="id"]:checked') == null) {
    document.body.classList.add("select_popup");
  }
});

document.querySelector(".size_button_inner").addEventListener("click", function (event) {
  document.body.classList.remove("select_popup");
});





